import { COLORS } from "@/constants/Colors/colors";
import { TableBody, TableCell, TableRow, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

export default function CustomNoData({ numOfCells, rowText, button = null }) {
  const globalState = useSelector((state) => state?.global);
  return (
    <TableRow sx={{ width: "100%" }}>
      <TableCell
        colSpan={numOfCells}
        style={{ textAlign: "center", padding: "30px", width: "100%" }}
      >
        <Typography
          fontFamily="Noor-bold"
          fontSize={30}
          color={globalState?.isDarkMode ? COLORS.WHITE : COLORS.BLACK}
          sx={{ textShadow: "0px 3px 0px #2f8bc8", textAlign: "center" }}
        >
          {rowText}
        </Typography>
        {button}
      </TableCell>
    </TableRow>
  );
}
